<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import { ModelListSelect } from "vue-search-select";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Fees Additions",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Fees Additions",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Fees",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Student",
          sortable: true,
        },
        {
          key: "class",
          label: "Course",
          sortable: true,
        },
        {
          key: "term_field",
          label: "Level/Grade",
          sortable: true,
        },
        {
          key: "amount_field",
          label: "Amount",
          sortable: true,
        },

        {
          key: "reason",
          label: "Reason",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        student: "",
        amount: "",
        reason: "",
      },
      deletedata: {
        name: "",
        class: "",
        id: "",
      },
      editdata: {
        student: "",
        amount: "",
        reason: "",
        id: "",
      },
      studentError: "",
      amountError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("fees", ["FeesAdditions", "SaveStatus"]),
    ...mapGetters("students", ["AllStudents1", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.FeesAdditions ? this.FeesAdditions.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.FeesAdditions ? this.FeesAdditions.length : 1;
  },
  methods: {
    ...mapActions({
      FetchStudents: "students/fetchStudents1",
      FetchAdditions: "fees/fetchFeesAdditions",
      AddAddition: "fees/addFeesAddition",
      EditAddition: "fees/editFeesAddition",
      DeleteAddition: "fees/deleteFeesAddition",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.FeesAdditions ? this.FeesAdditions.length : 1;
      this.currentPage = 1;
    },

    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    addCommas() {
      this.data.amount = this.thousandSeperater(this.data.amount);
    },

    resetError() {
      this.studentError = "";
      this.amountError = "";
    },

    resetAddModal() {
      this.data.student = "";
      this.data.amount = "";
      this.data.reason = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.name = "";
      this.editdata.student = "";
      this.editdata.amount = "";
      this.editdata.reason = "";
      this.editdata.id = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.class = "";
      this.deletedata.id = "";
    },

    addAddition(modal) {
      if (this.data.student == "") {
        this.studentError = "Please Select a student";
        return;
      } else {
        this.studentError = "";
      }
      if (this.data.amount == "") {
        this.amountError = "Item amount is required";
        return;
      } else {
        this.amountError = "";
      }
      this.modal = modal;
      this.AddAddition(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.student = values.item.student;
      this.editdata.name = values.item.name;
      this.editdata.amount = this.thousandSeperater(values.item.amount);
      this.editdata.reason = values.item.reason;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
      this.deletedata.class = values.item.amount;
    },
    deleteAddition(modal) {
      this.modal = modal;
      this.DeleteAddition(this.deletedata);
      this.closeModal(modal);
    },
    editAddition(modal) {
      if (this.editdata.name == "") {
        this.studentError = "Student is required";
        return;
      } else {
        this.studentError = "";
      }
      if (this.editdata.amount == "") {
        this.amountError = "Amount field can't be empty";
        return;
      } else {
        this.amountError = "";
      }
      this.modal = modal;
      this.EditAddition(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchAdditions();
    this.FetchStudents();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_fees_addition')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  Fees Additions For All Classes
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-exemption-modal
                  class="btn btn-primary btn-sm float-end"
                >
                  <i
                    class="fa fa-plus"
                    v-if="
                      getCurrentUser.permissions.find((item) =>
                        item.permission.includes('add_fees_addition')
                      )
                    "
                  ></i>
                  Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="FeesAdditions ? FeesAdditions : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(term_field)="data">
                  {{ data.item.term }}
                </template>
                <template #cell(amount_field)="data">
                  {{ data ? thousandSeperater(data.item.amount) : "---" }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <!-- <button
                      class="btn btn-outline-primary btn-sm"
                      v-b-modal.edit-setting-modal
                      @click="showEditModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_fees_addition')
                        )
                      "
                    >
                      <i class="fa fa-edit"></i> Edit
                    </button> -->
                    <button
                      class="btn btn-outline-danger btn-sm"
                      v-b-modal.delete-setting-modal
                      @click="showDeleteModal(data)"
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('delete_fees_addition')
                        )
                      "
                    >
                      <i class="fa fa-trash"></i> Delete
                    </button>
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-exemption-modal"
        hide-footer
        @hidden="resetAddModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_fees_addition')
          )
        "
      >
        <template #modal-title> Record New Fees Addition</template>
        <div class="form-group mb-2">
          <label class="col-form-label">Student</label>
          <div class="input-group">
            <model-list-select
              :list="AllStudents1 ? AllStudents1 : []"
              v-model="data.student"
              option-value="id"
              option-text="names"
              class="mb-3"
              placeholder="Select Student"
              @input="resetError()"
            >
            </model-list-select>
          </div>
          <div class="text-danger" v-if="studentError">
            <em>{{ studentError }}</em>
          </div>
        </div>
        <div class="form-group mb-2">
          <label>Amount</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Amount"
              class="form-control"
              @input="resetError(), addCommas()"
              v-model="data.amount"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
          <small class="text-primary"
            >Amount Being Added this this student</small
          >
        </div>
        <div class="form-group mb-2">
          <label>Reason</label>
          <div class="input-group">
            <textarea
              rows=""
              cols=""
              placeholder="Enter Reason"
              class="form-control"
              v-model="data.reason"
            ></textarea>
          </div>
          <small class="text-primary">Reason For Adding</small>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger btn-sm"
            data-dismiss="modal"
            @click="closeModal('add-exemption-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="addAddition('add-exemption-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-setting-modal"
        hide-footer
        @hidden="resetEditModal()"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_fees_addition')
          )
        "
      >
        <template #modal-title>
          Edit Fees Addition for {{ editdata.name }} of ({{
            editdata.amount
          }})</template
        >
        <div class="form-group mb-2">
          <label>Amount</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Enter Amount"
              class="form-control"
              @input="resetError(), addCommas()"
              v-model="editdata.amount"
            />
          </div>
          <div class="text-danger" v-if="amountError">
            <em>{{ amountError }}</em>
          </div>
          <small class="text-primary">Amount Being Added to this student</small>
        </div>
        <div class="form-group mb-2">
          <label>Reason</label>
          <div class="input-group">
            <textarea
              rows=""
              cols=""
              placeholder="Enter Reason"
              class="form-control"
              v-model="editdata.reason"
            ></textarea>
          </div>
          <small class="text-primary">Reason For Adding</small>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-danger btn-sm"
            data-dismiss="modal"
            @click="closeModal('edit-setting-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="editAddition('edit-setting-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete setting starts -->
      <b-modal
        id="delete-setting-modal"
        hide-footer
        @hidden="resetDeleteModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('delete_fees_addition')
          )
        "
      >
        <template #modal-title>
          <h6 class="text-danger">
            Delete Fees Addition For{{ deletedata.name }} of
            {{ thousandSeperater(deletedata.class) }}
          </h6></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h6>
              Do you want to delete Fees Addition For {{ deletedata.name }} ?
              Click <b>Confirm</b> Button to delete.
            </h6>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            data-dismiss="modal"
            @click="closeModal('delete-setting-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-outline-danger btn-sm"
            @click="deleteAddition('delete-setting-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
